/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".check-pin-modal__content[_ngcontent-%COMP%]{--background:var(--color-background)}.check-pin-modal__content__title[_ngcontent-%COMP%]{font-size:2.5rem;margin-top:20vh;margin-bottom:5vh;font-weight:700;text-transform:uppercase;color:var(--color-background-dark-contrast)}.check-pin-modal__header[_ngcontent-%COMP%]:after{display:none}"];
export { styles as styles };
